import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
    username: Yup.string()
        .required('Informe um usuário válido.'),
    password: Yup.string()
        .required('Informe uma senha válida.'),
});

export const UsernameSchema = Yup.object().shape({
    username: Yup.string()
      .required('Informe um usuário válido.'),
  });
  
  export const PasswordSchema = Yup.object().shape({
    password: Yup.string()
      .required('Informe uma senha válida.'),
  });